let defaultFileSystem = undefined;
const ErrorNoFileSystem = new Error('please set the default FileSystem by call the setDefaultFileSystem');
export const setDefaultFileSystem = (fs) => {
    defaultFileSystem = fs;
};
export const getDefaultFileSystem = () => defaultFileSystem;
export const mustGetDefaultFileSystem = () => {
    if (defaultFileSystem) {
        return defaultFileSystem;
    }
    throw ErrorNoFileSystem;
};
